export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1F1813] text-[#E8DED5]/70 pt-14 pb-10"
    >
      <div className="container-xl">
        {/* Slogan */}
        <div className="text-center pb-10 border-b border-[#E8DED5]/10">
          <div className="overline !text-[#E4A57E]/80 mb-3">Notre signature</div>
          <div className="font-serif italic text-3xl md:text-4xl text-[#FAF8F5] leading-tight">
            « Votre sourire,{" "}
            <span className="text-[#E4A57E] not-italic font-medium">
              notre priorité.
            </span>{" "}
            »
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
          <div className="font-serif text-lg text-[#FAF8F5]">
            Cabinet Dentaire{" "}
            <span className="italic text-[#E4A57E]">La Gavotte</span>
          </div>
          <div className="text-xs tracking-wider uppercase">
            © {new Date().getFullYear()} — Tous droits réservés
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
